// fieldTypeAvailability.js

import { isSubtitleFieldType } from 'utilities/NodeSubtitle';

import { ONCE_ONLY_FIELD_TYPES } from './constants';

export function fieldTypeMatchesOnceOnlySlot(fieldType, onceOnlyType) {
  const normalizedFieldType = String(fieldType || '').trim().toLowerCase();
  const normalizedOnceOnlyType = String(onceOnlyType || '').trim().toLowerCase();

  if (normalizedFieldType === normalizedOnceOnlyType) return true;

  if (normalizedOnceOnlyType === 'subtitle' && isSubtitleFieldType(normalizedFieldType)) {
    return true;
  }

  return false;
}

export function isSchemaFieldOwnedByType(field, typeKey) {
  const cleanedTypeKey = String(typeKey || '').trim();
  if (!cleanedTypeKey) return true;

  const source = String(field?.source || '').trim();
  if (!source) return true;

  return source === cleanedTypeKey;
}

export function resolveUnavailableOnceOnlyTypes({
  existingFields = [],
  editingFieldName = '',
  typeKey = '',
  onceOnlyTypes = ONCE_ONLY_FIELD_TYPES,
} = {}) {
  return onceOnlyTypes.filter((type) => (
    (Array.isArray(existingFields) ? existingFields : []).some((field) => (
      String(field?.name || '') !== String(editingFieldName || '')
      && fieldTypeMatchesOnceOnlySlot(field?.type, type)
      && isSchemaFieldOwnedByType(field, typeKey)
    ))
  ));
}

export function findExistingOnceOnlyField({
  existingFields = [],
  onceOnlyType,
  typeKey = '',
} = {}) {
  return (Array.isArray(existingFields) ? existingFields : []).find((field) => (
    fieldTypeMatchesOnceOnlySlot(field?.type, onceOnlyType)
    && isSchemaFieldOwnedByType(field, typeKey)
  )) || null;
}
